import {createApp} from 'vue'
import App from './App.vue'

import 'element-plus/dist/index.css'
import './assets/icon/iconfont.css'
import './style/index.scss'
import './style/ag-grid.scss'
import "uno.css";

import 'virtual:svg-icons-register';
// easy资源
import './components/easy/css/global.scss';
// context菜单
import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css';

import pinia from '@/store/index'
import router from "@/router";

import EasyHook from './components/easy/core/Plugin';
import apiProtocol from './request/apiProtocol'

const app = createApp(App)
app.use(router)
app.use(pinia)
app.use(EasyHook, { apiProtocol })
app.mount('#app')

// app.use(ElementPlus, {
//   locale: zhCn
// })
